import {Container} from './components/Container'
import {useReducer} from 'react'
import {CustomLanding36252Context, initialState, reducer} from './reducer'
import {Header} from './components/Header'
import {HeroUnit} from './components/HeroUnit'
import {Steps} from './components/Steps'
import {Scrollable} from './components/Scrollable'
import {WhyUs} from './components/WhyUs'
import {TermsAndConditions} from './components/TermsAndConditions'
import {Links} from './components/Links'
import {Disclaimers} from './components/Disclaimers'
import {Warning} from './components/Warning'

export const CustomLanding36252: React.FC = () => {
  const [state, dispatcher] = useReducer(reducer, initialState)

  if (state.dismissed) return null

  return (
    <CustomLanding36252Context.Provider value={[state, dispatcher]}>
      <Container rtl={state.language === 'ar'}>
        <Scrollable>
          <Header />
          <HeroUnit />
          <Steps />
          <WhyUs />
          <TermsAndConditions />
          <Links />
          <Disclaimers />
          <Warning />
        </Scrollable>
      </Container>
    </CustomLanding36252Context.Provider>
  )
}
